import { Page } from "@/models/page-models/Page";

export const FactoryTicketCreate: Page = {
  "path": "factory-ticket",
  "name": "Create Factory Ticket",
  "props": {
    "data": {
      "title": "Create Factory Ticket",
      "printable": "FALSE",
      "url": "factory-ticket",
      "useMaxPageWidth": true,
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.factoryTicket.order",
                  "label": "Select Order",
                  "onVarUpdate": [
                    {
                      "executionOrder": 1,
                      "name": "copySelectedOrderData"
                    },
                    {
                      "executionOrder": 2,
                      "name": "copyPackingModeFilterFlag"
                    },
                    {
                      "executionOrder": 3,
                      "name": "getFilteredProcesses"
                    },
                    {
                      "executionOrder": 1,
                      "name": "openExistingFactoryTicketMessage",
                      "executeIf": "fn(LOGICAL,{{fetchedData.selectedOrderDetails.factoryTicket}},>,-1)"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.orders.data.docs",
                  "itemText": "productLine",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,orderDescription,{{__item}})",
                  "dropdownType": "search",
                  "searchFunctions": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyOrderSearchString",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "__selectedObject",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.orderSearch.search"
                      },
                      "name": "copyOrderSearchString"
                    },
                    {
                      "executionOrder": 2,
                      "name": "getAllOrders"
                    }
                  ]
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "custom_FtOrderDetails",
                  "variable": "fetchedData.selectedOrderDetails",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selectedOrderDetails}}",
                  "config": {
                    "checkForNumberOfTeeth": true,
                    "fnsAfterCheck": [
                      {
                        "name": "copyProductId",
                        "executionOrder": 1
                      },
                      {
                        "name": "openAddTeethPopup",
                        "executionOrder": 1
                      }
                    ]
                  }
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "custom_FtProcesses",
                  "variable": "formData.processes",
                  "label": "Processes",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selectedOrderDetails}}",
                  "items": "formData.processes",
                  "config": {
                    "orderDetailsVariable": "fetchedData.selectedOrderDetails",
                    "formVariable": "formData.factoryTicket",
                    "rmVariable": "fetchedData.goods.data",
                    "fixedWidth": true
                  }
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Add Process",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "openProcessPopup"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.filteredProcesses}}",
                  "color": "primary"
                }
              ]
            }
          ],
          "type": "genericGroup"
        },
        {
          "type": "popupGroup",
          "label": "Add New Process",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.selectedProcess",
                  "label": "Select Process",
                  "onVarUpdate": [
                    {
                      "executionOrder": 1,
                      "name": "getMachinesForProcess"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.filteredProcesses",
                  "itemText": "name",
                  "itemValue": "name",
                  "required": true
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.selectedMachine",
                  "label": "Select Machine",
                  "disabled": "FALSE",
                  "items": "fetchedData.selectedMachines",
                  "itemText": "name",
                  "itemValue": "_id",
                  "required": true
                }
              ]
            }
          ],
          "width": "500",
          "popupActions": [
            {
              "label": "Submit",
              "onClick": [
                {
                  "executionOrder": 1,
                  "name": "copySelectedMachineData"
                },
                {
                  "executionOrder": 2,
                  "name": "addProcess"
                },
                {
                  "executionOrder": 3,
                  "name": "closeProcessPopup",
                  "event": "addProcessToFactoryTicket",
                  "eventDataVariable": "fetchedData.processes"
                },
                {
                  "executionOrder": 4,
                  "name": "copyDisablePackingModeFilterFlag"
                },
                {
                  "executionOrder": 5,
                  "name": "getFilteredProcesses"
                }
              ]
            }
          ]
        },
        {
          "type": "popupGroup",
          "label": "Add Number Of Teeth",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.numberOfTeeth.numberOfTeeth",
                  "label": "Number Of Teeth",
                  "disabled": "FALSE"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Submit",
              "onClick": [
                {
                  "executionOrder": 1,
                  "name": "submitNumberOfTeeth"
                },
                {
                  "executionOrder": 2,
                  "name": "copyNumberOfTeeth"
                },
                {
                  "executionOrder": 3,
                  "name": "closeAddTeethPopup"
                }
              ]
            }
          ]
        },
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Save",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "saveFactoryTicket"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "secondary"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Print",
                  "disabled": "FALSE",
                  "color": "secondary",
                  "buttonType": "print"
                }
              ]
            }
          ],
          "type": "genericGroup"
        },
        {
          "type": "popupGroup",
          "label": "Existing Factory Ticket",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "labelType": "formula",
                  "formula": "The Factory Ticket # {{fetchedData.selectedOrderDetails.factoryTicket}} already exists for the current order.\nClick Redirect if you want to go there. Creating new Factory Ticket for the same order is not allowed."
                }
              ]
            }
          ],
          "width": "500",
          "popupActions": [
            {
              "label": "Redirect",
              "onClick": [
                {
                  "executionOrder": 1,
                  "name": "openExistingFactoryTicket"
                }
              ]
            }
          ]
        }
      ]
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultOrderSearchFilters",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultOrderSearchFilters",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.orderSearch",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "copyDefaultOrderSearchFilters"
      },
      {
        "executionOrder": 2,
        "name": "getAllMachines"
      },
      {
        "executionOrder": 2,
        "name": "getAllOrders"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getAllProcesses",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=processes",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.allProcesses"
        },
        "name": "getAllProcesses"
      },
      {
        "executionOrder": 3,
        "name": "getOrderFromUrl",
        "executeIf": "fn(LOGICAL,{{__query.order}},>,0)"
      }
    ],
    "functions": [
      {
        "name": "getAllMachines",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/machines/get",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.machines"
      },
      {
        "name": "getAllOrders",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/order/get?orderStatus=Unplanned&orderStatus=Pending+FT",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.orders",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.orderSearch"
      },
      {
        "name": "copySelectedOrderData",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__selectedObject",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedOrderDetails",
        "arg3Key": "destinationKeyType",
        "arg3Value": "Object"
      },
      {
        "name": "copyPackingModeFilterFlag",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getPackingFlag",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData",
        "arg3Key": "destinationKeyType",
        "arg3Value": "Object",
        "arg4Key": "append",
        "arg4Value": "TRUE"
      },
      {
        "name": "getPackingFlag",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "enablePacking": "fn(CONDITIONAL,fn(LOGICAL,fn(KEYED_ARRAY_SUM,fn(LOGICAL,{{__arrayItem.quantity}},!==,0),{{fetchedData.selectedOrderDetails.product.packingMode}},unit1),!==,fn(LENGTH,{{fetchedData.selectedOrderDetails.product.packingMode}})),Packing,'')"
        },
        "useFormula": true
      },
      {
        "name": "getFilteredProcesses",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "filterProcesses",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.filteredProcesses"
      },
      {
        "name": "filterProcesses",
        "type": "fnFilterArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.allProcesses.data.0.data",
        "arg2Key": "searchKey",
        "arg2Value": "name",
        "arg3Key": "searchValue",
        "arg3Value": "{{fetchedData.enablePacking}}",
        "arg4Key": "filterCondition",
        "arg4Value": "!=="
      },
      {
        "name": "openProcessPopup",
        "type": "fnOpenPopup",
        "arg1Key": "popupName",
        "arg1Value": "Add New Process"
      },
      {
        "name": "closeProcessPopup",
        "type": "fnClosePopup",
        "arg1Key": "popupName",
        "arg1Value": "Add New Process"
      },
      {
        "name": "filterPossibleMachinesForProcess",
        "type": "fnFilterArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.machines.data",
        "arg2Key": "searchKey",
        "arg2Value": "possibleProcesses",
        "arg3Key": "searchValue",
        "arg3Value": "{{fetchedData.selectedProcess}}",
        "arg4Key": "searchKeyValueType",
        "arg4Value": "Array"
      },
      {
        "name": "getMachinesForProcess",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "filterPossibleMachinesForProcess",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedMachines"
      },
      {
        "name": "addProcess",
        "type": "fnPushToArray",
        "arg1Key": "sourceFn",
        "arg1Value": "createInitialProcessData",
        "arg2Key": "destinationVariable",
        "arg2Value": "fetchedData.processes"
      },
      {
        "name": "getSelectedMachineData",
        "type": "fnFindInArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.machines.data",
        "arg2Key": "searchKey",
        "arg2Value": "_id",
        "arg3Key": "searchValue",
        "arg3Value": "fetchedData.selectedMachine"
      },
      {
        "name": "copySelectedMachineData",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getSelectedMachineData",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedMachineData"
      },
      {
        "name": "createInitialProcessData",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "type": "fetchedData.selectedProcess",
          "machine": "fetchedData.selectedMachineData.name",
          "machineDetail": "fetchedData.selectedMachineData"
        }
      },
      {
        "name": "saveFactoryTicket",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/factoryticket/save",
        "arg2Key": "postData",
        "arg2Value": "formData.factoryTicket",
        "arg3Key": "fnsAfterSubmit",
        "arg3Value": "[{\"name\":\"redirectToSavedFactoryTicket\",\"executionOrder\":1,\"event\":\"requestRmTransfer\"}]",
        "arg4Key": "storeResponse",
        "arg4Value": "TRUE",
        "arg5Key": "validationVariable",
        "arg5Value": "isFactoryTicketValid"
      },
      {
        "name": "copyProductId",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getProductId",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.numberOfTeeth"
      },
      {
        "name": "getProductId",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "product": "fetchedData.selectedOrderDetails.product._id"
        }
      },
      {
        "name": "openAddTeethPopup",
        "type": "fnOpenPopup",
        "arg1Key": "popupName",
        "arg1Value": "Add Number Of Teeth"
      },
      {
        "name": "closeAddTeethPopup",
        "type": "fnClosePopup",
        "arg1Key": "popupName",
        "arg1Value": "Add Number Of Teeth"
      },
      {
        "name": "submitNumberOfTeeth",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/product/numberofteeth",
        "arg2Key": "postData",
        "arg2Value": "fetchedData.numberOfTeeth"
      },
      {
        "name": "copyNumberOfTeeth",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "fetchedData.numberOfTeeth.numberOfTeeth",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedOrderDetails.product.numberOfTeeth",
        "arg3Key": "destinationKeyType",
        "arg3Value": "Number"
      },
      {
        "name": "redirectToSavedFactoryTicket",
        "type": "fnRedirect",
        "arg1Key": "redirectUrl",
        "arg1Value": "/factory-ticket/{{__response.data._id}}"
      },
      {
        "name": "getOrderFromUrl",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getSelectedOrderFromOrderParam",
        "arg2Key": "destinationKey",
        "arg2Value": "formData.factoryTicket"
      },
      {
        "name": "getSelectedOrderFromOrderParam",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "order": "__query.order"
        }
      },
      {
        "name": "getDisablePackingFlag",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "enablePacking": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedProcess}},'),==,'Packing'),Packing,'')"
        },
        "useFormula": true
      },
      {
        "name": "copyDisablePackingModeFilterFlag",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getDisablePackingFlag",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData",
        "arg3Key": "destinationKeyType",
        "arg3Value": "Object",
        "arg4Key": "append",
        "arg4Value": "TRUE"
      },
      {
        "name": "openExistingFactoryTicketMessage",
        "type": "fnOpenPopup",
        "arg1Key": "popupName",
        "arg1Value": "Existing Factory Ticket"
      },
      {
        "name": "openExistingFactoryTicket",
        "type": "fnRedirect",
        "arg1Key": "redirectUrl",
        "arg1Value": "/factory-ticket/{{fetchedData.selectedOrderDetails.factoryTicket}}"
      },
      {
        "name": "getDefaultOrderSearchFilters",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "apge": "1",
          "limit": "50",
          "search": "{{__query.order}}"
        },
        "useFormula": true
      }
    ]
  },
  "forRole": "PRODUCTION_PLANNER",
  "visible": true,
  "routerPriority": 90
}